import type { ComponentType, CSSProperties } from 'react'

import {
  AppleIcon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  Award01Icon,
  BitcoinIcon,
  BombIcon,
  BookOpen02Icon,
  Calendar03Icon,
  Camera01Icon,
  Cancel01Icon,
  ChampionIcon,
  ChartAverageIcon,
  CheckmarkCircle02Icon,
  CircleIcon,
  ClipboardIcon,
  Clock01Icon,
  CloudIcon,
  CodeIcon,
  Coins01Icon,
  Copy01Icon,
  CrownIcon,
  Delete02Icon,
  DiceFaces06Icon,
  DollarCircleIcon,
  DoorIcon,
  DownloadSquare01Icon,
  Edit02Icon,
  EyeIcon,
  ViewOffIcon,
  Facebook01Icon,
  File01Icon,
  FireIcon,
  Flag02Icon,
  FloppyDiskIcon,
  GiftIcon,
  GoogleIcon,
  HelpCircleIcon,
  HourglassIcon,
  Image01Icon,
  InformationCircleIcon,
  LicenseIcon,
  Link01Icon,
  Loading03Icon,
  LockIcon,
  Mail01Icon,
  Maximize01Icon,
  Message01Icon,
  MessageMultiple01Icon,
  MinusSignSquareIcon,
  NaturalFoodIcon,
  PlayIcon,
  PlusSignSquareIcon,
  QrCodeIcon,
  QuestionIcon,
  RankingIcon,
  Route03Icon,
  SaveEnergy01Icon,
  Search01Icon,
  Share08Icon,
  SecurityCheckIcon,
  Shield01Icon,
  SmileIcon,
  Sad01Icon,
  SparklesIcon,
  SquareLock02Icon,
  StarIcon,
  TaskDaily02Icon,
  TextIcon,
  ThumbsUpIcon,
  Ticket01Icon,
  Tick02Icon,
  TickDouble01Icon,
  Timer02Icon,
  TShirtIcon,
  UploadSquare01Icon,
  UserGroupIcon,
  UserIcon,
  ViewIcon,
  YoutubeIcon,
  ZoomInAreaIcon,
  FavouriteIcon
} from '@hugeicons/react'
import clsx from 'clsx'

export type HugeIconComponent = ComponentType<Record<string, unknown>>
export type IconVariant = 'stroke' | 'solid' | 'duotone' | 'twotone' | 'bulk'

export const ICONS: Record<string, HugeIconComponent> = {
  'angle-left': ArrowLeft01Icon,
  'angle-right': ArrowRight01Icon,
  apple: AppleIcon,
  'arrow-left': ArrowLeft01Icon,
  'arrow-right': ArrowRight01Icon,
  'arrow-progress': Route03Icon,
  'arrows-rotate': Loading03Icon,
  ban: Cancel01Icon,
  bars: TaskDaily02Icon,
  'block-question': QuestionIcon,
  bomb: BombIcon,
  'cake-candles': GiftIcon,
  calendar: Calendar03Icon,
  camera: Camera01Icon,
  'caret-down': ArrowDown01Icon,
  'caret-up': ArrowUp01Icon,
  check: Tick02Icon,
  'check-circle': CheckmarkCircle02Icon,
  'check-double': TickDouble01Icon,
  'chevron-down': ArrowDown01Icon,
  'chevron-left': ArrowLeft01Icon,
  child: UserIcon,
  circle: CircleIcon,
  'circle-check': CheckmarkCircle02Icon,
  'circle-dollar': Coins01Icon,
  'circle-dot': CircleIcon,
  'circle-exclamation': InformationCircleIcon,
  'circle-info': InformationCircleIcon,
  'circle-minus': MinusSignSquareIcon,
  'circle-notch': Loading03Icon,
  'circle-plus': PlusSignSquareIcon,
  'circle-xmark': Cancel01Icon,
  plus: PlusSignSquareIcon,
  'clipboard-check': ClipboardIcon,
  'clipboard-list-check': ClipboardIcon,
  clock: Clock01Icon,
  close: Cancel01Icon,
  code: CodeIcon,
  'comment-alt-times': Cancel01Icon,
  'comment-lines': Message01Icon,
  copy: Copy01Icon,
  crown: CrownIcon,
  dice: DiceFaces06Icon,
  'door-open': DoorIcon,
  'down-to-line': DownloadSquare01Icon,
  down: ArrowDown01Icon,
  'ellipsis-v': TaskDaily02Icon,
  'ellipsis-vertical': TaskDaily02Icon,
  'empty-set': HelpCircleIcon,
  'exclamation-circle': InformationCircleIcon,
  expand: Maximize01Icon,
  eye: EyeIcon,
  'eye-slash': ViewOffIcon,
  eyes: EyeIcon,
  'face-party': SmileIcon,
  'face-sad-sweat': Sad01Icon,
  'face-smile-beam': SmileIcon,
  'face-smile-hearts': FavouriteIcon,
  'facebook-f': Facebook01Icon,
  'file-alt': File01Icon,
  'file-arrow-down': DownloadSquare01Icon,
  'file-dashed-line': File01Icon,
  fire: FireIcon,
  flag: Flag02Icon,
  'floppy-disk': FloppyDiskIcon,
  gift: GiftIcon,
  google: GoogleIcon,
  'head-side': UserIcon,
  heart: FavouriteIcon,
  'heart-crack': FavouriteIcon,
  'hourglass-end': HourglassIcon,
  image: Image01Icon,
  infinity: LicenseIcon,
  link: Link01Icon,
  lips: SmileIcon,
  lock: SquareLock02Icon,
  'magnifying-glass': Search01Icon,
  'magnifying-glass-plus': ZoomInAreaIcon,
  message: Message01Icon,
  'message-lines': Message01Icon,
  messages: MessageMultiple01Icon,
  'minus-square': MinusSignSquareIcon,
  mustache: UserIcon,
  nose: UserIcon,
  'paper-plane': UploadSquare01Icon,
  'party-horn': GiftIcon,
  pen: Edit02Icon,
  'person-hiking': UserIcon,
  play: PlayIcon,
  'plus-square': PlusSignSquareIcon,
  'podium-star': RankingIcon,
  'pot-food': NaturalFoodIcon,
  qrcode: QrCodeIcon,
  save: FloppyDiskIcon,
  search: Search01Icon,
  'share-nodes': Share08Icon,
  'shield-check': SecurityCheckIcon,
  shirt: TShirtIcon,
  'slash-forward': ArrowRight01Icon,
  sparkles: SparklesIcon,
  'spinner-third': Loading03Icon,
  spinner: Loading03Icon,
  'square-exclamation': InformationCircleIcon,
  star: StarIcon,
  stars: StarIcon,
  text: TextIcon,
  thumbtack: Flag02Icon,
  ticket: Ticket01Icon,
  times: Cancel01Icon,
  trash: Delete02Icon,
  'treasure-chest': GiftIcon,
  trophy: Award01Icon,
  up: ArrowUp01Icon,
  user: UserIcon,
  'user-bounty-hunter': UserIcon,
  'user-group': UserGroupIcon,
  'user-hair': UserIcon,
  'xmark-large': Cancel01Icon,
  youtube: YoutubeIcon,
  'chart-mixed': ChartAverageIcon,
  'user-circle': UserIcon,
  cloud: CloudIcon,
  'hand-holding-heart': FavouriteIcon,
  bitcoin: BitcoinIcon,
  envelope: Mail01Icon
}

const FS_SIZE_MAP: Record<string, number> = {
  'fs-9': 12,
  'fs-1': 14,
  'fs-2': 16,
  'fs-3': 18,
  'fs-4': 20,
  'fs-5': 22,
  'fs-6': 24,
  'fs-7': 28,
  'fs-8': 32,
  'fs-2x': 32,
  'fs-2qx': 40,
  'fs-3x': 48,
  'fs-3qx': 56,
  'fs-4x': 64,
  'fs-5qx': 72
}

const parseSizeFromClassName = (className = '', explicitSize?: number) => {
  if (explicitSize) return explicitSize

  for (const token of className.split(/\s+/)) {
    if (FS_SIZE_MAP[token]) return FS_SIZE_MAP[token]
  }

  return 20
}

export type AppIconProps = {
  name?: string
  className?: string
  size?: number
  variant?: IconVariant
  spin?: boolean
  style?: CSSProperties
}

export const AppIcon = ({
  name,
  className = '',
  size,
  variant = 'duotone',
  spin = false,
  style
}: AppIconProps) => {
  const Icon = (name && ICONS[name]) || HelpCircleIcon
  const resolvedSize = parseSizeFromClassName(className, size)

  return (
    <Icon
      size={resolvedSize}
      variant={variant}
      className={clsx(className, spin && 'icon-spin')}
      style={style}
    />
  )
}

export const LoadingSpinner = (props: Omit<AppIconProps, 'name'>) => (
  <AppIcon name="spinner-third" spin variant="duotone" {...props} />
)

export {
  AppleIcon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  Award01Icon,
  BombIcon,
  Calendar03Icon,
  Camera01Icon,
  Cancel01Icon,
  CheckmarkCircle02Icon,
  ClipboardIcon,
  Clock01Icon,
  Coins01Icon,
  CrownIcon,
  Delete02Icon,
  DiceFaces06Icon,
  DoorIcon,
  DownloadSquare01Icon,
  Edit02Icon,
  EyeIcon,
  ViewOffIcon,
  Facebook01Icon,
  File01Icon,
  Flag02Icon,
  FloppyDiskIcon,
  GiftIcon,
  GoogleIcon,
  HelpCircleIcon,
  HourglassIcon,
  Image01Icon,
  InformationCircleIcon,
  LicenseIcon,
  Link01Icon,
  Loading03Icon,
  LockIcon,
  Maximize01Icon,
  Message01Icon,
  MinusSignSquareIcon,
  PlayIcon,
  PlusSignSquareIcon,
  QrCodeIcon,
  QuestionIcon,
  Route03Icon,
  Search01Icon,
  Share08Icon,
  SecurityCheckIcon,
  Shield01Icon,
  SquareLock02Icon,
  StarIcon,
  TaskDaily02Icon,
  TextIcon,
  Ticket01Icon,
  Tick02Icon,
  TickDouble01Icon,
  TShirtIcon,
  UploadSquare01Icon,
  UserGroupIcon,
  UserIcon,
  YoutubeIcon,
  ZoomInAreaIcon,
  FavouriteIcon
}
